import { render } from "./transfer_templates_edit.vue?vue&type=template&id=011fa5be"
import script from "./transfer_templates_edit.vue?vue&type=script&lang=js"
export * from "./transfer_templates_edit.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__